import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { sendContactMessage } from "../../utils/api";

const quillModules = {
    toolbar: [
        ["bold", "italic", "underline"],
        [{ list: "bullet" }],
        ["link"],
        ["clean"],
    ],
};

const quillFormats = [
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "link",
];

const FormArea = () => {
    const [form, setForm] = useState({
        name: "",
        email: "",
        subject: "",
        message: "",
    });

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState(null);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleQuillChange = (value) => {
        setForm((prev) => ({
            ...prev,
            message: value,
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;

        setLoading(true);
        setStatus(null);

        try {
            const res = await sendContactMessage(form);

            const data =
                typeof res?.json === "function"
                    ? await res.json()
                    : res;

            if (!res?.ok && data?.status !== "OK") {
                throw new Error(data?.message || "Failed to send message");
            }

            setStatus("success");
            setForm({
                name: "",
                email: "",
                subject: "",
                message: "",
            });
        } catch (err) {
            console.error("[CONTACT FORM]", err);
            setStatus("error");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <div className="row">
                {/* NAME */}
                <div className="col-md-6 mb-25">
                    <div className="contact__form-area-item">
                        <input
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            required
                            value={form.name}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* EMAIL */}
                <div className="col-md-6 md-mb-25">
                    <div className="contact__form-area-item">
                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            required
                            value={form.email}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* SUBJECT */}
                <div className="col-md-12 mb-25">
                    <div className="contact__form-area-item">
                        <input
                            type="text"
                            name="subject"
                            placeholder="Subject"
                            value={form.subject}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                {/* MESSAGE - ReactQuill */}
                <div className="col-md-12 mb-25">
                    <div className="contact__form-area-item">
                        <ReactQuill
                            theme="snow"
                            value={form.message}
                            onChange={handleQuillChange}
                            modules={quillModules}
                            formats={quillFormats}
                            placeholder="Write your message..."
                            className="custom-quill"
                        />
                    </div>
                </div>

                {/* SUBMIT */}
                <div className="col-md-12">
                    <div className="contact__form-area-item">
                        <button
                            className="build_button"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? "Sending..." : "Submit Message"}
                            <i className="flaticon-right-up" />
                        </button>
                    </div>

                    {status === "success" && (
                        <p className="text-success mt-2">
                            ✅ Message sent successfully.
                        </p>
                    )}

                    {status === "error" && (
                        <p className="text-danger mt-2">
                            ❌ Failed to send message. Please try again.
                        </p>
                    )}
                </div>
            </div>
        </form>
    );
};

export default FormArea;
